<template>
  <div class="header">
    <mobile-controls></mobile-controls>
    <div class="pull-left sm-table hidden-xs hidden-sm">
      <div class="header-inner">
        <div class="brand inline">
          <img src="~assets/img/logo-sofradom.png" alt="logo" data-src="~assets/img/logo-sofradom.png" data-src-retina="~assets/img/logo-sofradom.png" width="140">
        </div>
        <!-- <div>
        <ul class="breadcrumb">
          <li>
            <p>Espace Agence</p>
          </li> -->
          <!-- <li>
            <a v-if="currentRoute === 'customer' || currentRoute === 'contract-management' href="#" class="active">Client</a>
          </li> -->
          <!-- <li v-if="currentRoute === 'customer' || currentRoute === 'contract-management' ">
            {{get_customer_name}}
          </li> -->
        <!-- </ul>
        </div> -->
        <notification-list></notification-list>
        <search-bar></search-bar>
      </div>
    </div>
    <!-- <quickview-toggle></quickview-toggle> -->
    <user-info :logout="logoutAndResetUser" :email="me.email"></user-info>
  </div>
</template>

<style lang="scss" scoped>
  img {
    margin-left: 72px;
  }
</style>

<script type="text/babel">
import MobileControls from './MobileControls'
import NotificationList from './NotificationList'
import QuickviewToggle from './QuickviewToggle'
import SearchBar from './SearchBar'
import UserInfo from './UserInfo'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    MobileControls,
    NotificationList,
    QuickviewToggle,
    SearchBar,
    UserInfo
  },

  computed: {
    ...mapState({
      me: state => state.user.me,
      agencies: state => state.user.agencies
    }),

    currentRoute () {
      const name = this.$route.name
      return name
    },

    get_customer_name : function() {
      const cname = this.$store.state.customer.profile.name
      return cname
    }

  },

  methods: {
    ...mapActions(['logoutUser', 'resetUserState']),
    ...mapActions('notifications', ['resetNotificationsState']),
    logoutAndResetUser () {
      this.resetNotificationsState()
      this.resetUserState()
      this.logoutUser()
    }
  },
}
</script>



// WEBPACK FOOTER //
// client/components/Header/Header.vue